import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { ISoundNotificationMessage } from '../../../interfaces/sound-notifications-message.interface';
import { ISoundNotificationsAdapterService } from './sound-notifications-adapter.interface';
import { map, take } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';

const INTERVAL_BETWEEN_NOTIFICATIONS = 3_000;
const STARTING_DELAY = 3_000;
const MAX_NUMBER_OF_NOTIFICATIONS = 30;

@injectable()
export class SoundNotificationsAdapterMock implements ISoundNotificationsAdapterService {

    soundNotificationsObservable(): Observable<ISoundNotificationMessage> {
        AlkLogger.debug('[SoundNotificationsAdapterMock#soundNotificationsObservable]');

        return timer(STARTING_DELAY, INTERVAL_BETWEEN_NOTIFICATIONS).pipe(
            take(MAX_NUMBER_OF_NOTIFICATIONS),
            map(() => {
                let numberOfNotifications = Math.floor(Math.random() * 5) + 1;
                let id = Math.floor(Math.random() * 100) * 1000;

                const notifications = [];
                while (numberOfNotifications !== 0) {
                    notifications.push({ id: (id++).toString() });
                    numberOfNotifications--;
                }

                return { notifications };
            }),
        );
    }
}
